import { createAsyncThunk } from "@reduxjs/toolkit"
import paginationFeature from "./pagination"
import queryFeature from "./query"

export const generateSliceCore = ({NAME, ITEMS_PER_PAGE}) => {
  return {
    initialState: {
      ...queryFeature.generator.generateInitialState(ITEMS_PER_PAGE),
      ...paginationFeature.generator.generateInitialState(ITEMS_PER_PAGE),
    },
    action: {
      setQuery: createAsyncThunk(
        `${NAME}/query/setQuery`,
        async (options) => {
          return JSON.parse(JSON.stringify(options))
        }
      ),
      setQueryFulfilled: (state, action) => {
        state.query = action.payload
      },
      setCurrentPage: createAsyncThunk(
        `${NAME}/pagination/setCurrentPage`,
        async (options) => {
          return options
        }
      ),
      setCurrentPageFulfilled: (state, action) => {
        state.currentPage = action.payload
        // @todo: make sure next page is available
        state.nextPage = state.currentPage+1

        if(action.payload > 0){
          state.previousPage = state.currentPage-1
        }
      },
      setSorter: createAsyncThunk(
        `${NAME}/sorter/setSorter`,
        async (options) => {
          console.log(options)
          return options
        }
      ),
      setSorterFulfilled: (state, action) => {
        state.sorter = action.payload
      },
    }
  }
}

export const generateCoreExtraReducers = ({
  setQuery,
  setCurrentPage,
  setSorter,
  setQueryFulfilled,
  setCurrentPageFulfilled,
  setSorterFulfilled,
}) => {
  return {
    [setQuery.fulfilled]: setQueryFulfilled,
    [setCurrentPage.fulfilled]: setCurrentPageFulfilled,
    [setSorter.fulfilled]: setSorterFulfilled,
  };
};
